__turbopack_context__.v({
  "container": "CenteredPage-module__rgcPhW__container",
});
